// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconInputArrowUp = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7">
            <polygon
                fill="currentColor"
                points="5.499 .003 5.981 .525 10.518 5.434 11 5.956 10.036 6.997 9.554 6.475 5.499 2.085 1.443 6.478 .961 7 0 5.956 .482 5.434 5.016 .522 5.499 0"
            />
        </svg>
    );
};

export default React.memo(IconInputArrowUp);
